import api from '../api/axios';

// Authentifizierter Datei-Download (PDF/CSV/JSON) über die API
export async function downloadFile(url, fallbackName, params) {
  const res = await api.get(url, { params, responseType: 'blob' });
  const disposition = res.headers?.['content-disposition'] || '';
  const match = /filename="([^"]+)"/.exec(disposition);
  const filename = match ? match[1] : fallbackName;
  const blobUrl = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}

export const fmtDate = d => (d ? new Date(d).toLocaleDateString('de-DE') : '–');
export const fmtDateTime = d => (d ? new Date(d).toLocaleString('de-DE') : '–');
export const fmtEUR = v => (v || 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

export function endOfCurrentMonth() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1, 0);
}
